import { Outlet } from "react-router-dom";

import Header from "components/Header";
import TabSwitch from "components/TabSwitch";
import { routes } from "constants/routes";
import useDeviceType from "hooks/useDeviceType";
import { useUserFeature } from "hooks/useUserFeature";
import MainLayout from "layouts/Main";
import styles from "./style.module.scss";

export default function SavedPosts() {
  const { isDesktop } = useDeviceType();
  const { isShipper, isSavedLoadsRole, isSavedPostsRole } = useUserFeature();

  const SavedPostsLabel = () =>
    isSavedLoadsRole ? (isShipper ? "Saved Trucks" : "Saved Posts") : "Saved Loads";

  const SAVED_POSTS_TAB_ITEMS = [
    {
      id: 0,
      label: "Saved Loads",
      value: "loads",
      link: routes.SAVED_LOADS
    },
    {
      id: 1,
      label: "Saved Trucks",
      value: "trucks",
      link: routes.SAVED_TRUCKS
    }
  ];

  return (
    <MainLayout
      desktopTitle={SavedPostsLabel()}
      {...(isDesktop
        ? { title: SavedPostsLabel() }
        : { customHeader: <Header label={SavedPostsLabel()} goBackPath={routes.HOME} /> })}
      className={styles.savedTruckContainer}>
      {!isSavedPostsRole && <TabSwitch options={SAVED_POSTS_TAB_ITEMS} />}

      <div className={styles.body}>
        <Outlet />
      </div>
    </MainLayout>
  );
}
